import { render, staticRenderFns } from "./PurchaseOptionLegals.vue?vue&type=template&id=bcea9808&scoped=true&"
import script from "./PurchaseOptionLegals.vue?vue&type=script&lang=js&"
export * from "./PurchaseOptionLegals.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOptionLegals.vue?vue&type=style&index=0&id=bcea9808&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea9808",
  null
  
)

export default component.exports